import ListItem from './listItem-TEMPLATE_VERSION'

export default ListItem
